var _path, _path2, _rect, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromotions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.81 52.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-promotions-sales-methods-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.76,46.87c0,2.87,2.94,5.21,6.52,5.21h0a6.16,6.16,0,0,0,6.5-6.48V36.46c0-1.59-2.93,0-6.5,0h0c-3.58,0-6.52,2.34-6.52,5.21Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.12,46.88c0,2.86,2.93,5.21,6.51,5.21h0c3.58,0,6.51-2.35,6.51-5.21V41.67c0-2.86-2.93-5.21-6.51-5.21h0c-3.58,0-6.51-.26-6.51,2.61Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.18,
    y: 15.62,
    width: 15.62,
    height: 15.62,
    rx: 2.6,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.23,13c-.52-.43-.85,9.52,7,15.17s8-11.6,2.91-8.25S.75,13.46.23,13Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.87,4c1.07-2.58-14.55-2.31-14.29,10.59s10.83,8.15,9.17,1.21S61.8,6.6,62.87,4Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31,23.44C7.31,36.38,20.13,46.87,36,46.87S64.6,36.38,64.6,23.44,51.77,0,36,0,7.31,10.49,7.31,23.44ZM22.93,7.81s6.47-2.6,11.68-2.6,11.76,2.6,11.76,2.6V13s-6.55-2.6-11.76-2.6S22.93,13,22.93,13Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotions);
export default __webpack_public_path__ + "static/media/promotions.970b8102f2bcd1744847e4636847fd40.svg";
export { ForwardRef as ReactComponent };